import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Head from '../components/Head';
import Foot from '../components/Foot';

const apiUrl = process.env.REACT_APP_API_URL;

function getYouTubeEmbedUrl(url) {
  const match = url.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([\w-]{11})/);
  return match ? `https://www.youtube.com/embed/${match[1]}` : null;
}

function VideoGallery() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const response = await axios.get(`${apiUrl}/api/public/video-gallery`);
        if (response.data.success) {
          setVideos(response.data.videos);
        } else {
          setError(response.data.message || 'Failed to load video gallery.');
        }
      } catch (err) {
        setError('Error fetching video gallery. Please try again later.');
      } finally {
        setLoading(false);
      }
    };

    fetchVideos();
  }, []);

  return (
    <>
      <Head />
      {/* Start Hero */}
      <section className="common-page-hero">
        <img
          src="assets/img/bg/common-bg.png"
          className="common-hero-bg ak-bg"
          alt="..."
        />
        <div className="common-hero-content">
          <div className="common-hero-info">
            <div className="ak-section-heading ak-style-1 animation-title-content animation-style3" style={{ marginTop: 100 }}>
              <p className="ak-section-subtitle animation-title">Discover</p>
              <h2 className="ak-section-title animation-title">Video Gallery</h2>
            </div>
            <p className="back-btn">
              <a href="/">Home</a> / Discover / Video Gallery
            </p>
          </div>
          <a href="" className="phone-number">
            +91 90486 48777
          </a>
        </div>
      </section>
      {/* End Hero */}
      <div className="ak-height-60 ak-height-lg-50" />
      <section>
        <div className="container">
          <div className="row row-cols-1 row-cols-md-2 g-4">
            {loading ? (
              <div className="col-12 text-center">Loading video gallery...</div>
            ) : error ? (
              <div className="col-12 text-center text-danger">{error}</div>
            ) : videos.length === 0 ? (
              <div className="col-12 text-center text-warning">No videos found.</div>
            ) : (
              videos.map((video) => {
                const embedUrl = video.video_type === 'youtube' ? getYouTubeEmbedUrl(video.video_url) : null;
                return (
                  <div className="col" key={video.id}>
                    <div className="image-card h-100 bg-white shadow-lg rounded-lg overflow-hidden">
                      <div style={{ position: 'relative', paddingTop: '56.25%' }}>
                        {video.video_type === 'youtube' ? (
                          embedUrl ? (
                            <iframe
                              src={embedUrl}
                              title={video.title || `video-${video.id}`}
                              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                              allowFullScreen
                              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0 }}
                            />
                          ) : (
                            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f3f4f6' }}>
                              Invalid YouTube link
                            </div>
                          )
                        ) : (
                          <video
                            controls
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', background: '#000' }}
                          >
                            <source src={`${apiUrl}/${video.video_path}`} />
                            Your browser does not support the video tag.
                          </video>
                        )}
                      </div>
                      {video.title && (
                        <div className="p-4">
                          <h5 className="text-lg font-semibold">{video.title}</h5>
                        </div>
                      )}
                    </div>
                  </div>
                );
              })
            )}
          </div>
        </div>
      </section>
      <div className="ak-height-20 ak-height-lg-30" />
      <Foot />
    </>
  );
}

export default VideoGallery;
